import {
  WHITE,
  TEXT_COLOR,
  TITLE_COLOR_GK,
  SECONDARY_BTN_GK,
  FOOTER_BG_GK,
} from "../../utils/colors";

import {
  TITLE_SIZE,
  SUB_TITLE_SIZE,
  TEXT_SIZE,
  SUB_TEXT_SIZE,
} from "../../utils/fonts";

import { useEffect } from "react";
import DynamicTitle from "../../components/DynamicTitle";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import OnePost from "../../components/OnePost";
import CustomButton from "../../components/CustomButton";
import "./Noticia.css";
import FooterBar from "../../components/FooterBar";

export default function Noticia() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="Noticia">
      <DynamicTitle
        pageTitle="Grupo Krause - Destaques"
        pageMeta="Grupo Krause"
        pageContent="Acesse nossos avisos, notícias, projetos, eventos e novidades."
      />
      <OnePost
        white={WHITE}
        titleColor={TITLE_COLOR_GK}
        textColor={TEXT_COLOR}
        titleSize={TITLE_SIZE}
        subTitleSize={SUB_TITLE_SIZE}
        textSize={TEXT_SIZE}
        subTextSize={SUB_TEXT_SIZE}
        btnColor={SECONDARY_BTN_GK}
      />
      <Container>
        <Row>
          <Col className="noticia-bottom-col">
            <CustomButton
              className="secondary-btn"
              variant="secondary"
              href="/destaques/"
              icon=""
              content="VOLTAR AOS DESTAQUES"
              backgroundColor={WHITE}
              fontFamily="Unageo-Semibold"
              fontColor={SECONDARY_BTN_GK}
              fontSize={20}
              width={280}
              borderColor={SECONDARY_BTN_GK}
              disabled={false}
            />
          </Col>
        </Row>
      </Container>
      <FooterBar titleColor={TITLE_COLOR_GK} footerBarBG={FOOTER_BG_GK} />
    </div>
  );
}
